import { createContext } from 'react'

const ApiErrorHandlerContext = createContext(null)

export default ApiErrorHandlerContext
